class CapitalGain {
    totalAmount;
    totalPercentage;
    valuationType;
    resale;
    crowdfunding;
    constructor(data) {
        this.totalAmount = data.totalAmount;
        this.totalPercentage = data.totalPercentage;
        this.valuationType = data.typeOfValuation;
        this.resale = data.resale;
        this.crowdfunding = data.crowdfunding;
    }
}
export default CapitalGain;
